import React from 'react';

/**
 * Encoding-safe show/hide password glyph (no emoji — avoids UTF-8 mojibake in builds).
 */
export default function PasswordVisibilityIcon({ visible }) {
  if (visible) {
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
          d="M3 3l18 18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M10.6 10.7a2 2 0 002.8 2.8M9.9 5.1A10.5 10.5 0 0121 12c-.7 1.2-1.6 2.3-2.6 3.2M6.1 6.2C4.7 7.4 3.5 8.9 2.5 10.5a1.6 1.6 0 000 1.7C4.7 15.7 8.1 18 12 18c1.1 0 2.1-.2 3.1-.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M2.5 10.5a1.6 1.6 0 000 1.7C4.7 15.7 8.1 18 12 18s7.3-2.3 9.5-5.8a1.6 1.6 0 000-1.7C19.3 7 15.9 4.7 12 4.7S4.7 7 2.5 10.5z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
